/* NR product landing sections — shared behaviour. Idempotent: safe to load once per section and to re-run in the theme editor. */
(function () {
  "use strict";
  if (window.__nrPdpLoaded) return;
  window.__nrPdpLoaded = true;

  var reduceMotion = !!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches);
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function once(el, key) { if (!el || el.getAttribute("data-nr-ready-" + key)) return false; el.setAttribute("data-nr-ready-" + key, "1"); return true; }

  /* in-page anchors (CTAs -> offer) */
  document.addEventListener("click", function (event) {
    var link = event.target.closest ? event.target.closest('.nr-page a[href^="#"]') : null;
    if (!link) return;
    var id = link.getAttribute("href").slice(1);
    var target = id ? document.getElementById(id) : null;
    if (!target) return;
    event.preventDefault();
    target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
  });

  function initAnnounce(bar) {
    if (!once(bar, "announce")) return;
    var track = $(".nr-announce__track", bar);
    var items = $$(".nr-announce__item", track);
    if (items.length < 2 || reduceMotion) return;
    var clone = items[0].cloneNode(true);
    clone.setAttribute("aria-hidden", "true");
    track.appendChild(clone);
    var index = 0, paused = false;
    track.addEventListener("transitionend", function () {
      if (index >= items.length) { index = 0; track.style.transition = "none"; track.style.transform = "translateX(0)"; }
    });
    bar.addEventListener("mouseenter", function () { paused = true; });
    bar.addEventListener("mouseleave", function () { paused = false; });
    window.setInterval(function () {
      if (paused || document.hidden || !document.body.contains(bar)) return;
      index += 1;
      track.style.transition = "transform .6s ease";
      track.style.transform = "translateX(" + (-100 * index) + "%)";
    }, 4000);
  }

  function initCarousel(root) {
    if (!once(root, "carousel")) return;
    var viewport = $(".nr-carousel__viewport", root);
    var slides = $$(".nr-tcard", root);
    var dotsWrap = $(".nr-carousel__dots", root);
    var prev = $(".nr-carousel__arrow--prev", root);
    var next = $(".nr-carousel__arrow--next", root);
    if (!viewport || !slides.length) return;
    var dots = [], pages = 1, step = 1, current = 0;
    function measure() {
      step = slides.length > 1 ? (slides[1].offsetLeft - slides[0].offsetLeft) : viewport.clientWidth;
      if (step <= 0) step = viewport.clientWidth || 1;
      pages = Math.max(1, Math.round(Math.max(0, viewport.scrollWidth - viewport.clientWidth) / step) + 1);
    }
    function goTo(i) { viewport.scrollTo({ left: Math.max(0, Math.min(pages - 1, i)) * step, behavior: reduceMotion ? "auto" : "smooth" }); }
    function setActive(i) {
      current = i;
      dots.forEach(function (d, k) { d.classList.toggle("is-active", k === i); if (k === i) d.setAttribute("aria-current", "true"); else d.removeAttribute("aria-current"); });
    }
    function buildDots() {
      var before = pages;
      measure();
      if (dots.length && before === pages) { setActive(Math.min(pages - 1, Math.round(viewport.scrollLeft / step))); return; }
      dotsWrap.innerHTML = ""; dots = [];
      for (var i = 0; i < pages; i += 1) {
        var b = document.createElement("button");
        b.type = "button"; b.className = "nr-dot";
        b.setAttribute("aria-label", "Pokaż opinię " + (i + 1) + " z " + pages);
        b.addEventListener("click", goTo.bind(null, i));
        dotsWrap.appendChild(b); dots.push(b);
      }
      setActive(Math.min(pages - 1, Math.round(viewport.scrollLeft / step)));
    }
    var ticking = false;
    viewport.addEventListener("scroll", function () {
      if (ticking) return; ticking = true;
      window.requestAnimationFrame(function () { ticking = false; var i = Math.min(pages - 1, Math.round(viewport.scrollLeft / step)); if (i !== current) setActive(i); });
    }, { passive: true });
    prev.addEventListener("click", function () { goTo(current <= 0 ? pages - 1 : current - 1); });
    next.addEventListener("click", function () { goTo(current >= pages - 1 ? 0 : current + 1); });
    var timer;
    window.addEventListener("resize", function () { window.clearTimeout(timer); timer = window.setTimeout(buildDots, 150); });
    buildDots();
    window.addEventListener("load", buildDots);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(buildDots);
  }

  function initGallery(root) {
    if (!once(root, "gallery")) return;
    var stage = $(".nr-gallery__stage", root);
    var slides = $$(".nr-gallery__slide", root);
    var thumbs = $$(".nr-gallery__thumb", root);
    if (!slides.length) return;
    var active = 0;
    function show(i) {
      active = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle("is-active", k === active); if (k === active) s.removeAttribute("aria-hidden"); else s.setAttribute("aria-hidden", "true"); });
      thumbs.forEach(function (t, k) { t.classList.toggle("is-active", k === active); t.setAttribute("aria-pressed", k === active ? "true" : "false"); });
      var t = thumbs[active];
      if (t && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.parentNode.scrollTo({ left: t.offsetLeft - t.parentNode.offsetLeft - 16, behavior: reduceMotion ? "auto" : "smooth" });
    }
    thumbs.forEach(function (t, k) { t.addEventListener("click", function () { show(k); }); });
    var startX = null;
    stage.addEventListener("touchstart", function (e) { startX = e.changedTouches[0].clientX; }, { passive: true });
    stage.addEventListener("touchend", function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX; startX = null;
      if (Math.abs(dx) > 40) show(active + (dx < 0 ? 1 : -1));
    }, { passive: true });
  }

  function initBuy(wrap) {
    if (!once(wrap, "buy")) return;
    var form = $("form", wrap);
    if (!form) return;
    var packs = $$(".nr-pack", form);
    var subscribe = $("[data-nr-subscribe]", form);
    var planField = $("[data-nr-plan]", form);
    var button = $("[data-nr-atc]", form);
    var label = $("[data-nr-atc-label]", form);
    var status = $("[data-nr-atc-status]", form);
    var idleLabel = label ? label.textContent : "";
    function sub() { return !!(subscribe && subscribe.checked); }
    function render() {
      var s = sub();
      packs.forEach(function (pack) {
        var input = $(".nr-pack__input", pack);
        pack.classList.toggle("is-selected", input.checked);
        var map = [["[data-nr-price]", s ? "data-sub-price" : "data-price"], ["[data-nr-unit]", s ? "data-sub-unit" : "data-unit"], ["[data-nr-save]", s ? "data-sub-save" : "data-save"]];
        map.forEach(function (m) { var el = $(m[0], pack); var v = pack.getAttribute(m[1]); if (el && v) el.textContent = v; });
      });
      if (planField) {
        var planId = planField.getAttribute("data-plan-id");
        planField.value = s && planId ? planId : "";
        planField.disabled = !(s && planId);
      }
    }
    function say(text, isError) { if (!status) return; status.textContent = text; status.classList.toggle("is-error", !!isError); }
    function chosen() {
      for (var i = 0; i < packs.length; i += 1) { var input = $(".nr-pack__input", packs[i]); if (input.checked) return packs[i]; }
      return null;
    }
    form.addEventListener("change", function () { render(); say(""); });
    form.addEventListener("submit", function (event) {
      var pack = chosen();
      if (!pack) { event.preventDefault(); return; }
      var input = $(".nr-pack__input", pack);
      if (!input.value) { /* sample mode: no product picked in the theme editor yet */
        event.preventDefault();
        var name = $(".nr-pack__name", pack).textContent;
        label.textContent = wrap.getAttribute("data-added-label") || idleLabel;
        say(label.textContent + ": " + name + " · " + $("[data-nr-price]", pack).textContent);
        window.setTimeout(function () { label.textContent = idleLabel; }, 2200);
        return;
      }
      if (!window.fetch || !window.FormData) return; /* native form post fallback */
      event.preventDefault();
      render();
      button.disabled = true;
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
      fetch(rootUrl + "cart/add.js", { method: "POST", headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: new FormData(form) })
        .then(function (res) { if (!res.ok) throw new Error("cart"); window.location.href = wrap.getAttribute("data-redirect") || (rootUrl + "checkout"); })
        .catch(function () { button.disabled = false; say(wrap.getAttribute("data-error") || "", true); });
    });
    render();
  }

  function init(ctx) {
    $$("[data-nr-announce]", ctx).forEach(initAnnounce);
    $$("[data-nr-carousel]", ctx).forEach(initCarousel);
    $$("[data-nr-gallery]", ctx).forEach(initGallery);
    $$("[data-nr-buy]", ctx).forEach(initBuy);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(document); }); else init(document);
  document.addEventListener("shopify:section:load", function (event) { init(event.target); });
  document.addEventListener("shopify:block:select", function (event) {
    var slide = event.target.closest ? event.target.closest(".nr-tcard") : null;
    if (slide && slide.parentNode && slide.parentNode.parentNode) slide.parentNode.parentNode.scrollTo({ left: slide.offsetLeft - slide.parentNode.offsetLeft, behavior: "auto" });
    if (event.target.tagName === "DETAILS") event.target.open = true;
  });
})();
